import React from "react"
import { Link as GatsbyLink } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import {
  Accordion as AccordionContainer,
  AccordionItem,
  AccordionButton,
  Box,
  AccordionPanel,
  Heading,
  Link,
  Text,
} from "@chakra-ui/react"

import { ArrowForward } from "./FeaturedArticle"

const Accordion = ({ data }) => {
  return (
    <>
      {data?.ueberschrift && (
        <Heading
          as="h6"
          fontFamily="CocoSharpL-Bold"
          fontSize="1.25rem"
          lineHeight="1.25rem"
          mb={4}
        >
          {data.ueberschrift}
        </Heading>
      )}
      <AccordionContainer allowToggle mb={20}>
        {data?.aufklappbareDatenOderProjekte?.map((item, index) => {
          if (!item.projekteUndDaten?.uri) {
            return null
          }
          const { id, title, uri, pagebuilder, featuredImage } =
            item.projekteUndDaten
          const image =
            featuredImage &&
            getImage(featuredImage.node.localFile.childImageSharp)
          return (
            <AccordionItem borderTop={0} borderBottom="1px" key={id}>
              {({ isExpanded }) => (
                <>
                  <h2>
                    <AccordionButton pl={0}>
                      <Box flex="1" textAlign="left" pr={1}>
                        <Text
                          as="span"
                          fontFamily="CocoSharpL-Regular"
                          fontSize="1rem"
                          lineHeight="1.3125rem"
                        >
                          {title}
                        </Text>
                      </Box>
                      {isExpanded ? (
                        <MinusIcon fontSize="12px" />
                      ) : (
                        <AddIcon fontSize="12px" />
                      )}
                    </AccordionButton>
                  </h2>
                  <AccordionPanel
                    px={0}
                    pb={4}
                    fontFamily="CocoSharpL-Regular"
                    color="dark_blue"
                  >
                    {image && (
                      <>
                        <GatsbyImage
                          image={image}
                          style={{ maxHeight: "400px", marginBottom: "0.5rem" }}
                          alt={featuredImage.node.altText || title}
                        />
                      </>
                    )}
                    {pagebuilder?.fixeElementeTop?.teaserText}
                    <Box mt={4}>
                      <Link
                        as={GatsbyLink}
                        to={uri}
                        color="dark_blue"
                        aria-label={`Weitere Infos zu "${title}"`}
                      >
                        <ArrowForward />
                        weitere Infos
                      </Link>
                    </Box>
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          )
        })}
      </AccordionContainer>
    </>
  )
}

export default Accordion

const AddIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <g id="Group_178" data-name="Group 178" transform="translate(-999 -1234)">
      <g
        id="Group_178-2"
        data-name="Group 178"
        transform="translate(1004 1239)"
      >
        <line
          id="Line_31"
          data-name="Line 31"
          y2="20"
          transform="translate(10)"
          fill="none"
          stroke="#212121"
          strokeWidth="1"
        />
        <line
          id="Line_32"
          data-name="Line 32"
          x2="20"
          transform="translate(0 10)"
          fill="none"
          stroke="#212121"
          strokeWidth="1"
        />
      </g>
      <g
        id="Ellipse_11"
        data-name="Ellipse 11"
        transform="translate(999 1234)"
        fill="none"
        stroke="#212121"
        strokeWidth="1"
      >
        <circle cx="15" cy="15" r="15" stroke="none" />
        <circle cx="15" cy="15" r="14.5" fill="none" />
      </g>
    </g>
  </svg>
)

const MinusIcon = () => (
  <svg
    id="Group_179"
    data-name="Group 179"
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="0 0 30 30"
  >
    <g id="Group_178" data-name="Group 178" transform="translate(5 15)">
      <line
        id="Line_32"
        data-name="Line 32"
        x2="20"
        fill="none"
        stroke="#212121"
        strokeWidth="1"
      />
    </g>
    <g
      id="Ellipse_11"
      data-name="Ellipse 11"
      fill="none"
      stroke="#212121"
      strokeWidth="1"
    >
      <circle cx="15" cy="15" r="15" stroke="none" />
      <circle cx="15" cy="15" r="14.5" fill="none" />
    </g>
  </svg>
)
